// * Components
import { PrimaryButton, TertiaryButton } from "components";
// * Utils
import { HeaderTextColor } from "utils";
// * Styles
import "./styles.scss";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const HeaderHeroContainer = styled.div`
  background-color: ${(props) => props.theme.headerHero.background};
  height: ${(props) => props.size}vh;
  h1,
  span {
    color: ${(props) => props.theme.headerHero.color};
  }
  &:before {
    background-image: url(${(props) =>
      props.image ||
      "https://images.unsplash.com/photo-1598135753163-6167c1a1ad65?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1738&q=80"});
  }
`;
export const HeaderHero = ({ title, description, image, size = "100" }) => {
  const history = useHistory();
  return (
    <HeaderHeroContainer image={image} className="header__hero" size={size}>
      <div className="header__hero__content">
        <HeaderTextColor modifiers={["heroHeader"]}>
          {title || "40 años de experiencia"}
        </HeaderTextColor>
        <div className="header__hero__subtitle">
          <span>{description || "en el mercado turístico."}</span>
        </div>
        <div className="header__hero__buttons">
          <PrimaryButton onClick={() => history.push("/vuelos")}>
            Ver circuitos
          </PrimaryButton>
          <TertiaryButton onClick={() => history.push("/cotizar/vuelos")}>
            Cotizar
          </TertiaryButton>
        </div>
      </div>
    </HeaderHeroContainer>
  );
};
